import React, { useState, useEffect } from 'react';
import {
  Accordion as ReactAccessibleAccordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import {
  AccordionTitle,
  SectionContent,
  StyledExpandMoreIcon,
} from './accordionStyle';
import SubAccordion from './SubAccordion';
import { SubAccordionLink } from './subAccordionStyle';
import { toAccordionId } from './accordionId';

const Accordion = ({ title, subtopics, body, open = false }) => {
  // Slugify so the accordion uuid is a valid HTML5 id (no spaces from the title).
  const accordionId = toAccordionId(typeof title === 'string' ? title : '');
  
  const [expanded, setExpanded] = useState(open ? [accordionId] : []);

  useEffect(() => {
    setExpanded(open ? [accordionId] : []);
  }, [open]);


  const toggleAccordion = (expandedItems) => {
    setExpanded(expandedItems);
  };

  return (
    <ReactAccessibleAccordion
      allowMultipleExpanded={false}
      allowZeroExpanded={true} 
      preExpanded={expanded}
      onChange={toggleAccordion}
    >
      <AccordionItem uuid={accordionId}>
        <AccordionItemHeading>
          <AccordionItemButton>
            <AccordionTitle feedback={body}>
              {title}
              <StyledExpandMoreIcon
                feedback={body}
                isActive={expanded.includes(accordionId)}
              />
            </AccordionTitle>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <SectionContent>
            {body
              ? body
              : subtopics.map((sub, index) =>
                  sub.link ? (
                    <SubAccordionLink
                      key={index}
                      href={sub.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {sub.icon && <img src={sub.icon} alt={sub.title} />}
                      {sub.title}
                    </SubAccordionLink>
                  ) : (
                    <SubAccordion
                      key={index}
                      title={sub.title}
                      content={sub.content}
                      video={sub.video}
                    />
                  ),
                )}
          </SectionContent>
        </AccordionItemPanel>
      </AccordionItem>
    </ReactAccessibleAccordion>
  );
};

export default Accordion;
